'use client';

export function RadioInput({
  name,
  label,
  value,
  checked,
  onChange,
}) {
  return (
    <label className="flex items-center">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary"
      />
      <span className="ml-2 text-xs text-gray-500">
        {label}
      </span>
    </label>
  );
}